window.customElements.define(
    "expandable-order-table",
    class extends HTMLElement {
        connectedCallback() {
            this.addEventListener(
                "click",
                (event) => {
                    const trigger = (event.target as HTMLElement)?.closest<HTMLElement>("[data-expandable-row-toggle]");

                    if (!trigger) {
                        return;
                    }

                    const targetId = trigger.getAttribute("aria-controls");
                    const target = targetId ? this.querySelector<HTMLElement>(`#${CSS.escape(targetId)}`) : null;

                    if (!target) {
                        return;
                    }

                    const expanding = target.hasAttribute("hidden");

                    target.toggleAttribute("hidden", !expanding);

                    this.querySelectorAll<HTMLElement>(`[data-expandable-row-toggle][aria-controls="${targetId}"]`)
                        .forEach((button) => {
                            button.setAttribute("aria-expanded", String(expanding));

                            const label = button.querySelector("[data-expandable-row-toggle-label]");

                            if (label) {
                                label.textContent = expanding ? "Hide details" : "View details";
                            }
                        });
                },
            );
        }
    },
);
